export const environment = {
  placement: "prod",
  production: true,
  route_hash: false,
  timezone: "America/Lima",
  code: "PE",
  currency: "PEN",
  country_code: "+51",
  gateway: {
    base_url: "https://services.rappi.pe",
  },
  currencySymbol: "S/.",
  country: {
    defaultLocale: "es-PE",
  },
  localeUrl: "https://cargo-core-api.s3.amazonaws.com/pe/cargo-logos/",
  oAuth: {
    client_id: "C5Ej64OTPM2AV9tpBHwXRMgFB2QIJw0bbPeKDg0v",
    redirect_uri: "https://turbo-wms.rappi.com.pe",
    response_type: "code",
    scope: "all",
    flowName: "GeneralOAuthFlow",
  },
  OAuthGateway: "https://www.rappi.com.pe/login-legacy",
  userToken: "2a681bbdd0d542e5c754da552c4fab58",
  auth0: {
    domain: "turbo-prod.us.auth0.com",
    clientId: "dcvPUE3iXkiFLpqzIpcCtYXCSd70PLAN",
    redirectUri: "https://turbo-wms.rappi.com.pe",
  },
};
